import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, Calendar, Users } from 'lucide-react';
import { AdminActions } from '../Admin/AdminActions';

interface Challenge {
  id: string;
  title: string;
  description: string;
  startDate: Date;
  endDate: Date;
  participants: number;
  reward: string;
  isActive: boolean;
}

interface ChallengeCardProps {
  challenge: Challenge;
  onJoin?: () => void;
  isAdmin?: boolean;
  onEdit?: (challenge: Challenge) => void;
  onArchive?: (challenge: Challenge) => void;
}

export function ChallengeCard({ challenge, onJoin, isAdmin, onEdit, onArchive }: ChallengeCardProps) {
  const navigate = useNavigate();

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-white rounded-[32px] p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#bbdde5] flex items-center justify-center">
            <Trophy className="w-5 h-5 text-black" />
          </div>
          <div>
            <h3 className="text-lg font-medium text-black">{challenge.title}</h3>
            <div className="flex items-center gap-4 text-sm text-gray-500 mt-1">
              <div className="flex items-center gap-1">
                <Calendar className="w-4 h-4" />
                <span>{formatDate(challenge.startDate)}</span>
              </div>
              <div className="flex items-center gap-1">
                <Users className="w-4 h-4" />
                <span>{challenge.participants} joined</span>
              </div>
            </div>
          </div>
        </div>
        {isAdmin ? (
          <AdminActions
            onEdit={() => navigate(`/challenges/edit/${challenge.id}`)}
            onArchive={() => onArchive?.(challenge)}
          />
        ) : challenge.isActive && onJoin && (
          <button
            onClick={onJoin}
            className="px-4 py-2 bg-black text-white rounded-xl text-sm hover:bg-black/80 transition-colors"
          >
            Join Challenge
          </button>
        )}
      </div>
      <div className="flex items-center justify-between">
        <div className="text-sm">
          <span className="text-gray-500">Reward: </span>
          <span className="text-black font-medium">{challenge.reward}</span>
        </div>
        <div className="text-sm">
          <span className="text-gray-500">Ends: </span>
          <span className="text-black font-medium">{formatDate(challenge.endDate)}</span>
        </div>
      </div>
    </div>
  );
}